export interface DialogDimensions {
  width: string;
  height: string;
  minWidth?: number | string;
  minHeight?: number | string;
}

export enum AlertDialogType {
  Error = 'error-alert',
  Success = 'success-alert',
  Info = 'info-alert',
  Default = 'alert',
}

export interface AlertDialogData {
  title?: string;
  type: AlertDialogType;
  okText?: string;
  subTitle?: string;
  message: string;
  defaultLables?: any;
}

export interface MultiErrorAlertDialogData {
  title?: string;
  okText?: string;
  subTitle?: string;
  errors: string[];
}
export interface ConfirmDialogButton {
  text: string;
  value: any;
  color?: string;
}

export interface ConfirmDialogData {
  title?: string;
  okText?: string;
  cancelText?: string;
  message: string;
  isRequired?: boolean;
  buttons?: ConfirmDialogButton[];
}

export interface InfoDialogData {
  title?: string;
  okText?: string;
  message: string;
}

export class DialogSize {
  static get small(): DialogDimensions {
    return { width: '36%', height: '25%', minWidth: 480, minHeight: 260 };
  }
  static get medium(): DialogDimensions {
    return { width: '50%', height: '50%', minWidth: 680, minHeight: 390 };
  }

  static get mediumExpanding(): DialogDimensions {
    return { width: '48%', height: 'auto', minWidth: 680, minHeight: 380 };
  }
  static get large(): DialogDimensions {
    return { width: '64%', height: '81%', minWidth: 720, minHeight: 540 };
  }

  static get fullHeight(): DialogDimensions {
    return { width: '64%', height: '96%', minWidth: 720, minHeight: 540 };
  }
}
